module.exports = __webpack_public_path__ + "img/add-user.3177df7d.png";